import { render, staticRenderFns } from "./publicaciones.vue?vue&type=template&id=5c8b4cb0&scoped=true&"
import script from "./publicaciones.vue?vue&type=script&lang=ts&"
export * from "./publicaciones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8b4cb0",
  null
  
)

export default component.exports